import axios from 'axios'
import moment from 'moment'
import { closeModal } from '../../../common/GlobalModal/redux/GlobalModalActions'
import { now } from '../../../utils/utcTime'
import {
  CREATE_OPPORTUNITY,
  DELETE_OPPORTUNITY,
  GET_OPPORTUNITIES,
  GET_OPPORTUNITY,
  OPPORTUNITY_EDITING,
  OPPORTUNITY_LOADING,
  UPDATE_OPPORTUNITY,
} from './opportunitiesTypes'

export const setLoading = (loading) => (dispatch) => {
  dispatch({ type: OPPORTUNITY_LOADING, payload: loading })
}

export const opportunityEditing = (editing) => (dispatch) => {
  dispatch({ type: OPPORTUNITY_EDITING, payload: editing })
}

export const getOpportunity = (id) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const res = await axios.get(`/opportunities/${id}`)
    dispatch({ type: GET_OPPORTUNITY, payload: res.data })
  } catch (e) {
    //
  } finally {
    dispatch(setLoading(false))
  }
}

export const contactDivisionsOpportunities = (options) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const res = await axios.get('/opportunities', { params: { ...options } })
    dispatch({ type: GET_OPPORTUNITIES, payload: res.data })
  } catch (err) {
    // notificationDanger('Something went wrong')
  } finally {
    dispatch(setLoading(false))
  }
}

export const createOpportunity = (data) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const formattedDate = moment(data.expectedCloseDate).utc().format('YYYY-MM-DD HH:mm:ss')
    const dataForDb = {
      ...data,
      expectedCloseDate: formattedDate,
      creationDate: now(),
    }

    const res = await axios.post('/opportunities', dataForDb)
    dispatch({ type: CREATE_OPPORTUNITY, payload: res.data })
    dispatch(closeModal('opportunity_modal'))
  } catch (err) {
    // notificationDanger('Something went wrong')
  } finally {
    dispatch(setLoading(false))
  }
}

export const updateOpportunity = (id, data) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const res = await axios.patch(`/opportunities/${id}`, data)
    dispatch({ type: UPDATE_OPPORTUNITY, payload: res.data })
    dispatch(closeModal('opportunity_modal'))
  } catch (e) {
    //
  } finally {
    dispatch(setLoading(false))
  }
}

export const deleteOpportunity = (id) => async (dispatch) => {
  try {
    dispatch(setLoading(true))
    const res = await axios.delete(`/opportunities/${id}`)
    dispatch({ type: DELETE_OPPORTUNITY, payload: res.data })
  } catch (e) {
    //
  } finally {
    dispatch(setLoading(false))
  }
}
